import { Gear } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Constants from '../../config/Constants';
import { set } from '../../features/app/appSlice';
import RestrictedContent from '../../pages/global/RestrictedContent';
import { idToUri } from '../../pages/global/UriHelper';
import { entityTypes } from '../../pages/translation/config/Constants';
import { useAppDispatch } from '../../store';
import { IconButton } from '../Buttons';
import { CommentButton } from './views/comments/CommentButton';

export interface SettingsSidebarContext {
    entity: any;
    entityType: string;
    documentId: number;
    uri: string;
    parentUri?: string;
    areaId?: number;
}

export default function SettingsSidebarButton({
    context,
    disabled = false,
    size = 20,
    icon: Icon = Gear,
    iconOnly = false,
    tooltip,
}: {
    context: SettingsSidebarContext;
    disabled?: boolean;
    size?: number;
    icon?: any;
    iconOnly?: boolean;
    tooltip?: string;
}) {
    const { sidebarFilters } = useSelector((state: any) => state.documents);
    const { showComments } = sidebarFilters;
    const { t } = useTranslation('documents');
    const dispatch = useAppDispatch();

    if (iconOnly) {
        return renderButton();
    }

    const showCommentsButton = context.entityType === entityTypes.AREA || context.entityType === entityTypes.BLOCK;

    return (
        <div className="position-relative d-flex">
            {renderButton()}

            {showCommentsButton && showComments && (
                <RestrictedContent module={Constants.modules.comments}>
                    <CommentButton
                        uri={idToUri(context.entity.id, context.entityType)}
                        parentUri={idToUri(context.documentId, entityTypes.DOCUMENT)}
                        handleMetaClick={handleMetaClick}
                        entity={context.entity}
                    />
                </RestrictedContent>
            )}
        </div>
    );

    function renderButton() {
        return (
            <IconButton
                icon={<Icon size={size} />}
                // @ts-expect-error: false-positive jsx error
                size="lg"
                // @ts-expect-error: false-positive jsx error
                className="flex-shrink-0 btn-settings"
                onClick={(event: Event) => {
                    event.stopPropagation();
                    handleMetaClick();
                }}
                disabled={disabled}
                data-uk-tooltip={
                    disabled ? undefined : (tooltip ?? t('documents:document.navbar.main.settingsSidebar.tooltip'))
                }
            />
        );
    }

    function handleMetaClick(landingTab = 'settings') {
        dispatch(
            set({
                key: 'sidebarContext',
                value: {
                    type: 'sidebarSettings',
                    context: {
                        ...context,
                        landingTab,
                    },
                },
            }),
        );
    }
}
